import { useAppSelector } from 'redux-store';

const useCanViewOrgPage = (): boolean => {
  return useAppSelector(state => {
    const profile = state.profile.profile;

    if (!profile) return false;

    const isBusinessAccount = profile.accountType === 'business';
    const hasOrganizations = (profile.organizations?.length ?? 0) > 0;

    return isBusinessAccount || hasOrganizations;
  });
};

export default useCanViewOrgPage;
